import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: theme.palette.layout.main,
    color: theme.palette.layout.textPrimary,
    border: 'none',
    borderRadius: 0,
  },
  closeBtn: {
    flex: 1,
  },
  alert: {
    width: '79%',
    margin: '0 auto',
  },
}))

export default useStyles
